import { encodeQueryString, getUrlVars } from "@/components/helpers/URL"
import { addSuffix } from "@/middleware/helpers/Suffix"
import { createAsyncThunk } from "@reduxjs/toolkit"
import _history from "routing/history"

export const clearSuffixLinkOperations = () => {
  const vars = getUrlVars(undefined)

  if (vars.id) {
    delete vars.id
  }

  const newPath = _history.location.pathname.split("/").slice(0, -1).join("/")
  if (newPath === "") {
    _history.push("/")
  } else {
    _history.push({
      ..._history.location,
      pathname: newPath,
      // @ts-expect-error: ERROR: check this ASAP
      search: encodeQueryString(vars),
    })
  }
}

export const clearSuffixLinkThunk = createAsyncThunk(
  "navigation/user/clearSuffixLink",
  (_, _thunkApi) => {
    clearSuffixLinkOperations()
  },
)

export const setSuffixLinkThunk = createAsyncThunk(
  "navigation/user/setSuffixLink",
  (suffix: string, _) => {
    addSuffix(suffix)

    return suffix
  },
)
